import { Component, Input, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';

import { Group } from '../../../shared/models/group.model';

import { DismissFlash } from '../../../shared/flash/store/flash.actions';

@Component({
  selector: 'appointments-reminder',
  template: require('./appointments-reminder.component.html'),
  styles: [require('./appointments-reminder.component.scss')]
})
export class AppointmentReminderComponent {
  @Input() group: Group;
  @Input() reason: any;
  @Input() authenticatedPatient: any;
  @Input() shortTermReminder: any;
  @Input() longTermReminder: any;

  private shortTermReminderOffsetsValues = { no_short_term_reminder: null, one_hour: 1, two_hours: 2, three_hours: 3 };
  private longTermReminderOffsetsValues = { no_long_term_reminder: null, one_day: 24, two_days: 48, three_days: 72 };

  constructor(
    private store: Store<AppState>,
    @Inject('$state') private $state,
    @Inject('$translate') private $translate,
  ) {}

  getShortTermReminderHours(): any {
    if (this.reason && this.reason.disableNotifications) {
      return;
    }
    if (this.reason && this.reason.shortTermReminderOffset) {
      return this.shortTermReminderOffsetsValues[this.reason.shortTermReminderOffset];
    }
    if (this.group.shortTermReminderOffset && this.group.shortTermReminderOffset) {
      return this.shortTermReminderOffsetsValues[this.group.shortTermReminderOffset];
    }
  }

  getLongTermReminderHours(): any {
    if (this.reason && this.reason.disableNotifications) {
      return;
    }

    if (this.reason && this.reason.longTermReminderOffset && this.reason.longTermReminderOffset) {
      return this.longTermReminderOffsetsValues[this.reason.longTermReminderOffset];
    }

    if (this.group.longTermReminderOffset && this.group.longTermReminderOffset) {
      return this.longTermReminderOffsetsValues[this.group.longTermReminderOffset];
    }
  }
  
  getReminderText() {
    const shortTermReminder = this.getShortTermReminderHours();
    const longTermReminder = this.getLongTermReminderHours();
    
    const notificationPreference = this.authenticatedPatient.subscription.notificationPreference;
    const reminders = notificationPreference === 'email' ? this.authenticatedPatient.email : this.authenticatedPatient.profile.contactMethods[0].number;

    if (shortTermReminder && longTermReminder) {
      if (shortTermReminder > 1) {
        return this.$translate.instant('appointment.reminder_notice_text_several_hours', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
      }
      return this.$translate.instant('appointment.reminder_notice_text_one_hour', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
    } else if (this.shortTermReminder || this.longTermReminder) {
      if (this.shortTermReminder && this.shortTermReminder > 1) {
        return this.$translate.instant('appointment.reminder_notice_text_one_reminder_several_hours', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
      }
      return this.$translate.instant('appointment.reminder_notice_text_one_reminder_one_hour', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
    }
    return '';
  }

  editReminders() {
    this.store.dispatch(new DismissFlash())
    this.$state.go('patients.id.update.appointment-reminders');
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/appointments/appointments-reminder/appointments-reminder.component.ts